export default __webpack_public_path__ + "static/media/036-Pope.89c02205.svg";